export const activityRegistrationStatus = {
    Approved: "Approved",
    Rejected: "Rejected",
    Pending: "Pending",
  };